import React from "react";
import {Button} from "primereact/button";
import ConfirmationMessageView from "./ConfirmationMessageView";


export default class ConfirmationMessageContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayDialog: false,
        };
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.executeAction = this.executeAction.bind(this);
    }

    openConfirmationMessage() {
        this.setState({
            displayDialog: true,
        });
    }

    onHideDialog() {
        this.setState({
            displayDialog: false,
        });
        if (this.props.afterHide) {
            this.props.afterHide();
        }
    }

    executeAction() {
        this.props.action();
        this.onHideDialog();
    }

    render() {
        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Confirmación</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.3em'}}>
                    <Button label="Cancelar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.3em'}}>
                    <Button label="Aceptar" onClick={this.executeAction}/>
                </div>
            </div>;

        let buttonOpen = <Button type="button"
                                 label={this.props.nameButton}
                                 style={{
                                     marginRight: '0.5em',
                                     visibility: this.props.invisible ? 'hidden' : '',
                                 }}
                                 className={this.props.className ? this.props.className : ""}
                                 onClick={this.openConfirmationMessage}/>;

        const {displayDialog} = this.state;

        return <ConfirmationMessageView displayDialog={displayDialog}
                                        onHideDialog={this.onHideDialog}
                                        dialogHeader={dialogHeader}
                                        buttonOpen={buttonOpen}
                                        dialogLegend={this.props.legend}
        />

    }
};